var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcFacebook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "facebook_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.956,
    height: 28.932,
    viewBox: "0 0 27.956 28.932",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".facebook_icon .a{fill:#e87722;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M55.526,108.032c.241-3.71.629-5.672.594-9.95a17.948,17.948,0,0,0-2.949.268l.46-5.132c.881.191,1.379.077,2.3.306.306-3.294.137-6.816,1.8-8.923,1.077-1.365,6.756-1.422,9.452-.734l-.23,5.507c-.076.115-2.239-.236-2.316-.16a3.826,3.826,0,0,0-2.886.442c-.153,1.187-.115,2.527-.268,3.753a13.6,13.6,0,0,0,3.294-.038l-.383,4.749c-1.111-.038-1.915-.038-3.14,0-.363,3.813,0,6.457-.064,9.92,4.423.008,8.165.017,9.113.017,0-10.388.637-18.29.956-28.614-3.441-.319-24.706.064-27.51-.319-.191,0-.127.255-.255.319.7,10.133.255,18.545-.191,28.614C44.624,108.028,49.939,108.025,55.526,108.032Z",
    transform: "translate(-43.302 -79.125)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFacebook);
export default __webpack_public_path__ + "static/media/ic_facebook.1321712d12ffe50472fb1fd2422c97b8.svg";
export { ForwardRef as ReactComponent };